// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* comment display */
.comment-video{
    width:100%
}

.comment-button-container{
    margin-top:10px;
}

#delete-button{
    background-color: rgba(139, 0, 0, 0.685);
    border: none;
    border-radius: 1em;
    color: white;
    margin: 0.25em;
    padding: 5px 10px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease, colour 0.3s ease;
}

#delete-button:hover{
    background-color: rgba(74, 6, 6, 0.938);
}

.comment-card{
    clear:both;
    margin-top:5px;
    margin-bottom:5px;
    padding:10px;
    margin-right:10%;
    border-radius: 10px;
    box-shadow: 0px 0px 1px rgba(10, 75, 132, 0.81);
}

.comment-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.comment-header img{
    border-radius: 50%;
    width:40px;
    height:40px;
    vertical-align:middle;
    margin-right:5px;
}

#comment-profile-picture, #comment-author{
   display:inline-block
}

.comment-media{
    display: flex;
    overflow-x: scroll;
    height:60%;
}

.comment-media img, .comment-media video{
    width:60%;
}

.comment-media img{
    margin-right:20px;
}


.scroll-info{
    font-weight:bold;
    color:#0056b3
}


/*comment form*/  

.sign-in-prompt, .no-comments{
    padding-top:10px;
    font-weight: bold;
}

.sign-in-prompt{
    text-align: right;
}

.create-comment {
    margin-left:10%;
    margin-top:5px;
    margin-bottom:5px;
    padding-bottom: 30px;
}
 
.comment-info{
    padding-top:10px;
    font-weight:bold;
}


#comment-content {
    margin-top:10px;
    border-radius:10px;
    border-color: #007bff;
    border-width:3px;
    resize:vertical;
}

.upload-file{
    background-color: #007bff;
    border: none;
    border-radius: 1em;
    color: white;
    margin: 0.25em;
    padding:10px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease, colour 0.3s ease;
    display:inline-block;
    text-align:center;
}

.upload-file:hover{
    background-color: #0056b3;
}

input[type="file"]::file-selector-button{
    display:none;
}

#comment-img, #comment-video{
    width:70%;
    display:flex;
    justify-content: right;
}

.media-input{
    display:grid;
    grid-template-columns: auto auto;
    justify-content: space-between;
    align-items: center;
}

.submit-comment{
    margin-left:60%;
    float:right;
    background-color: #007bff;
    border: none;
    border-radius: 1em;
    color: white;
    margin: 0.25em;
    padding:10px;
    margin-right:10px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease, colour 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./src/css/comments.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;GACG;AACH;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,gBAAgB;IAChB;AACJ;;;AAGA,eAAe;;AAEf;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;IACf,wDAAwD;IACxD,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,wDAAwD;AAC5D","sourcesContent":["/* comment display */\n.comment-video{\n    width:100%\n}\n\n.comment-button-container{\n    margin-top:10px;\n}\n\n#delete-button{\n    background-color: rgba(139, 0, 0, 0.685);\n    border: none;\n    border-radius: 1em;\n    color: white;\n    margin: 0.25em;\n    padding: 5px 10px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, colour 0.3s ease;\n}\n\n#delete-button:hover{\n    background-color: rgba(74, 6, 6, 0.938);\n}\n\n.comment-card{\n    clear:both;\n    margin-top:5px;\n    margin-bottom:5px;\n    padding:10px;\n    margin-right:10%;\n    border-radius: 10px;\n    box-shadow: 0px 0px 1px rgba(10, 75, 132, 0.81);\n}\n\n.comment-header{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.comment-header img{\n    border-radius: 50%;\n    width:40px;\n    height:40px;\n    vertical-align:middle;\n    margin-right:5px;\n}\n\n#comment-profile-picture, #comment-author{\n   display:inline-block\n}\n\n.comment-media{\n    display: flex;\n    overflow-x: scroll;\n    height:60%;\n}\n\n.comment-media img, .comment-media video{\n    width:60%;\n}\n\n.comment-media img{\n    margin-right:20px;\n}\n\n\n.scroll-info{\n    font-weight:bold;\n    color:#0056b3\n}\n\n\n/*comment form*/  \n\n.sign-in-prompt, .no-comments{\n    padding-top:10px;\n    font-weight: bold;\n}\n\n.sign-in-prompt{\n    text-align: right;\n}\n\n.create-comment {\n    margin-left:10%;\n    margin-top:5px;\n    margin-bottom:5px;\n    padding-bottom: 30px;\n}\n \n.comment-info{\n    padding-top:10px;\n    font-weight:bold;\n}\n\n\n#comment-content {\n    margin-top:10px;\n    border-radius:10px;\n    border-color: #007bff;\n    border-width:3px;\n    resize:vertical;\n}\n\n.upload-file{\n    background-color: #007bff;\n    border: none;\n    border-radius: 1em;\n    color: white;\n    margin: 0.25em;\n    padding:10px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, colour 0.3s ease;\n    display:inline-block;\n    text-align:center;\n}\n\n.upload-file:hover{\n    background-color: #0056b3;\n}\n\ninput[type=\"file\"]::file-selector-button{\n    display:none;\n}\n\n#comment-img, #comment-video{\n    width:70%;\n    display:flex;\n    justify-content: right;\n}\n\n.media-input{\n    display:grid;\n    grid-template-columns: auto auto;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.submit-comment{\n    margin-left:60%;\n    float:right;\n    background-color: #007bff;\n    border: none;\n    border-radius: 1em;\n    color: white;\n    margin: 0.25em;\n    padding:10px;\n    margin-right:10px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, colour 0.3s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
